import axios from "axios";
import {BACKEND_URI} from "../utils/Constants";
import {addRefreshToken, addSessionToken, getRefreshToken} from "../utils/auth";

export default class AxiosInstance {
    public static instance: any = null;
    public static interceptorIsSet: boolean = false;

    public static refreshToken = async () => {
        const refreshToken = getRefreshToken();
        if (refreshToken) {
            const ai = axios.create({
                baseURL: BACKEND_URI,
                headers: {
                    "X-Refresh-Token": refreshToken
                }
            });

            const response: any = await ai.post("/auth/refresh", {}).catch(() => {
                addSessionToken('');
                addRefreshToken('');
                window.location.reload();
            });

            if (response && response.data) {
                addSessionToken(response.data.auth_token);
                addRefreshToken(response.data.refresh_token);

                return response.data.auth_token;
            }
        }
    };

    public static getInstance:any = () => {
        if (!AxiosInstance.instance) {
            AxiosInstance.instance = axios.create({
                baseURL: BACKEND_URI
            });
        }

        if (!AxiosInstance.interceptorIsSet) {
            AxiosInstance.instance.interceptors.request.use(
                (config: any) => {
                    const token = sessionStorage.getItem("genToken");
                    if (token !== undefined) {
                        config.headers["X-Auth-Token"] = token;
                    }
                    return config;
                },
                (error: any) => {
                    return Promise.reject(error);
                }
            );

            AxiosInstance.instance.interceptors.response.use((response: any) => {
                return response;
            }, async (error: any) => {
                const originalConfig = error.config;
                if (error.response) {
                    if (error.response.status === 401 && !originalConfig._retry) {
                        originalConfig._retry = true;
                        try {
                            const authToken = await AxiosInstance.refreshToken();
                            if (authToken) {
                                return AxiosInstance.instance(originalConfig);
                            } else {
                                return Promise.reject(error);
                            }
                        } catch (err) {
                            return Promise.reject(err);
                        }
                    }
                }

                return Promise.reject(error);
            });
            AxiosInstance.interceptorIsSet = true;
        }

        return AxiosInstance.instance;
    };
};


// WEBPACK FOOTER //
// ./src/api/instance.ts